import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { ICourse } from 'models/prerequisites.model'
import { CourseHorizontalCard } from 'components/ui/CourseCards/components/molecules'
import { CourseStateType } from 'enum'
import styles from './style.module.scss'

interface Props {
  courses: ICourse[]
  learningPaths: ReactNode
}

export const WithCourses = ({ courses, learningPaths }: Props) => {
  const { t } = useTranslation()
  const prefix = 'courses.show.content.prerequisites.byCourses'

  return (
    <>
      <div className={styles.title}>{t(`${prefix}.title`)}</div>
      <div className={styles.content}>
        {t(`${prefix}.description.primaryPrefix`)}
        {learningPaths}
        {t(`${prefix}.description.primarySuffix`)}
      </div>
      {courses.map(({ course, enrol }, index) => (
        <div key={index} className={styles.course}>
          <CourseHorizontalCard
            course={course}
            enrol={enrol}
            directToLessons={false}
            enrolled={true}
            maxWidth="100%"
            showProgress={true}
            noAvailable={course.state === CourseStateType.Draft}
          />
        </div>
      ))}
    </>
  )
}
